import React, { Component } from 'react';
import { connect } from 'react-redux';

import { toggleSidebar } from 'actions/header';

import './styles.less';

const SIDEBAR_OPEN_CLASS = 'sidebar-open';

class NavigationSidebar extends Component {
  state = {
    open: false,
  };

  render() {
    return (
      <div className="navigationSidebar">
        <ul>{this.props.children}</ul>
      </div>
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.sidebarOpen === prevProps.sidebarOpen) {
      return;
    }

    document.body.classList.toggle(SIDEBAR_OPEN_CLASS, this.props.sidebarOpen);
  }

  componentWillUnmount() {
    const isOpen = document.body.classList.contains(SIDEBAR_OPEN_CLASS);

    if (isOpen) {
      this.props.toggleSidebar();
    }

    document.body.classList.remove(SIDEBAR_OPEN_CLASS);
  }
}

const mapStateToProps = state => {
  const { sidebar_open } = state.header;

  return {
    sidebarOpen: sidebar_open,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    toggleSidebar: () => dispatch(toggleSidebar()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NavigationSidebar);
